import { useEffect } from "react";
import { diagnosticsActions } from "./store/slice";
import { useAppDispatch } from "app/hooks";
import { useGetCurrentServerTimeQuery } from "services/streamingApi/diagnostics.api";

export interface ServerTimeLoaderProps {
    children?: React.ReactNode;
    refreshFeatureIntervalInMs?: number;
}

const ServerTimeLoader = (props: ServerTimeLoaderProps) => {
    const dispatch = useAppDispatch();

    // Periodically ping the GetServerTime endpoint to evaluate the duration of the most simple API call
    useGetCurrentServerTimeQuery(undefined, {
        pollingInterval: props.refreshFeatureIntervalInMs,
    });

    // Measure the duration of the GetServerTime API call using PerformanceObserver
    useEffect(() => {
        const observer = new PerformanceObserver((list) => {
            const matchedDuration = list
                .getEntries()
                .find((entry) =>
                    entry.name.includes("CurrentServerTime"),
                )?.duration;

            if (matchedDuration) {
                dispatch(diagnosticsActions.setDuration(matchedDuration));
            }
        });

        observer.observe({ type: "resource", buffered: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return props.children;
};

export { ServerTimeLoader };
